import { useEffect, useState } from 'react';
import { UpdateTradingPlanForm } from '../../../components/forms/Forms';
import { FaChevronLeft } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { PageSpinner } from '../../../components/spinner/Spinner';
import { config } from '../../../Constants';

const TradingPlan = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const baseURL = config.baseURL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/trading-plans/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(data[0]);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const { duration, maxDeposit, minDeposit, name, roi, _id } = data;

  return (
    <main className='content trading-plan-page'>
      <div className='title-btn'>
        <Link to='/dashboard/trading-plans'>
          <FaChevronLeft />
        </Link>
        <h1 className='title'>Trading Plan</h1>
      </div>

      {loading ? (
        <PageSpinner />
      ) : (
        <div className='blocks-cont'>
          <div className='grid'>
            {/* transaction details */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Trading Plan Details</h2>
              </div>
              <hr />

              <UpdateTradingPlanForm
                name={name}
                duration={duration}
                minDeposit={minDeposit}
                maxDeposit={maxDeposit}
                roi={roi}
                planId={_id}
              />
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default TradingPlan;
